export default __webpack_public_path__ + "static/media/n1.69bc8945.jpeg";